
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "TimeStamp49918727",
      {"classes":{"root":"TimeStamp49918727__root","time":"TimeStamp49918727__time"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  